import { cloneDeep } from 'lodash';

import { WorkspacesListingItem, OrganisationListItem } from '@futrli-sdk/workspaces';

import { DatasourcePollSyncUpdate } from '../types';

/**
 * Updates the workspaces list items with the latest datasource poll data (a new list will be returned, the original list will not be mutated).
 * @param workspaces The current list of workspaces
 * @param fetchedPollData The latest datasource poll data
 */
export const getUpdatedWorkspacesListItems = (
  workspaces: WorkspacesListingItem[],
  fetchedPollData: DatasourcePollSyncUpdate[]
): WorkspacesListingItem[] => {
  const newWorkspaces = cloneDeep(workspaces);

  const pollDataByDatasourceId = new Map(fetchedPollData.map(pollData => [pollData.id, pollData]));

  return newWorkspaces.map(workspace => ({
    ...workspace,
    organisations: workspace.organisations.map((organisation: OrganisationListItem) => {
      if (!organisation.datasource) {
        return organisation;
      }

      const matchingPollData = pollDataByDatasourceId.get(organisation.datasource.id);
      if (!matchingPollData) {
        return organisation;
      }

      return {
        ...organisation,
        datasource: {
          ...organisation.datasource,
          sync_status: matchingPollData.sync_status,
          sync_status_modified: matchingPollData.sync_status_modified
        }
      };
    })
  }));
};
